import cx from 'classnames';
import Link, { LinkProps } from '../Link';

type HeaderMenuLinkProps = LinkProps & {
  invert?: boolean;
  scrolled?: boolean;
  title: string;
};

export const HeaderDesktopMenuLink = ({ href, title, invert, scrolled, ...props }: HeaderMenuLinkProps) => <Link
  className={cx('block button button-size-medium', {
    'button-primary-link-header': !invert || scrolled,
    'button-primary-link-header-invert': invert && !scrolled,
  })}
  href={href}
  {...props}
>
  {title}
</Link>
